import React from 'react'
import { ResponsiveScrollView } from 'APP/Converse/Layout'
import { NativeStackScreenProps } from '@react-navigation/native-stack'
import SelfNavSearchCard from 'APP/Converse/SelfNavSearchCard'
import i18n from 'APP/I18n'
import { Distance } from 'APP/Converse/SelfNavSearchCard/style'
import { TouchableOpacity } from 'react-native'
import {
  Divider,
  Section,
  SectionTitle,
  OpeningHoursContainer,
  OpeningHoursText,
  WebsiteText,
} from './styles'
import { formatOpeningHours, handleLink, OpeningHours } from './helper'
import { handleDirections, handleCall } from 'APP/Helpers/SelfNavActions'

export type SelfNavigationDetailScreenProps = NativeStackScreenProps<
  ReactNavigation.RootParamList,
  'selfNavigationDetail'
>

function SelfNavigationDetailScreen({ route }: SelfNavigationDetailScreenProps) {
  const { place, specialty } = route.params
  const distance = `${place.distance?.kilometers} ${i18n.t('SelfNavSearchCard.distance.metric')}`
  const openingHours = formatOpeningHours(place?.opening_hours?.opening_hours_by_day)
  return (
    <ResponsiveScrollView>
      {/* Header */}
      <Section>
        {distance && <Distance variant="bodySmall">{distance}</Distance>}
        <SelfNavSearchCard
          title={place.name}
          type={specialty}
          onDirections={() => handleDirections(place, specialty)}
          onCall={() => handleCall(place, specialty)}
          style={{
            backgroundColor: 'transparent',
            borderWidth: 0,
            padding: 0,
            borderBottomWidth: 0,
          }}
        />
      </Section>
      {/* Opening Hours */}
      {openingHours.length > 0 && (
        <>
          <Divider />
          <Section>
            <SectionTitle variant="h3">
              {i18n.t('SelfNavigationDetailScreen.openingHours')}
            </SectionTitle>
            {openingHours?.map((openingHour: OpeningHours) => (
              <OpeningHoursContainer key={openingHour.day}>
                <OpeningHoursText variant={openingHour.isToday ? 'subheaderBold' : 'subheader'}>
                  {openingHour.day}
                </OpeningHoursText>
                <OpeningHoursText variant={openingHour.isToday ? 'subheaderBold' : 'subheader'}>
                  {openingHour.open}
                </OpeningHoursText>
              </OpeningHoursContainer>
            ))}
          </Section>
        </>
      )}
      {/* Website */}
      {place.website && (
        <>
          <Divider />
          <Section>
            <SectionTitle variant="h3">{i18n.t('SelfNavigationDetailScreen.website')}</SectionTitle>
            <TouchableOpacity onPress={() => place?.website && handleLink(place?.website)}>
              <WebsiteText variant="subheader">{place.website}</WebsiteText>
            </TouchableOpacity>
          </Section>
        </>
      )}
    </ResponsiveScrollView>
  )
}

export default SelfNavigationDetailScreen
